export const Gender = {
	MALE: "männlich",
	FEMALE: "weiblich",
	UNKNOWN: "keine Angabe"
}

export const RoleEnum = {
	ADMIN: "Administration",
	SUPPORT: "Support",
	BOOKING_OFFICE: "Verkaufsstelle",
	MERCHANT: "Händler",
	DISPATCHER: "Disponent",
	DATA_COLLECTOR: "Datensammlung",
	EARLY_ACCESS: "early-access",
	RESELLER: "Reseller",
	IMPERSONATOR: "IMPERSONATOR",
	XXX_HIDE_SENSIBLE_MERCHANT_MENU: "XXX_HIDE_SENSIBLE_MERCHANT_MENU",  // QUICKFIX to hide some menu items.
	TICKET_SCANNER: "Lockout Scanner-User (WAF via Zuul)",
	MARKETING: "Marketing",
	ACCOUNTANT: "Abrechner"
}

export class Role {
	value: string;
	roleName: string;

	constructor( value: string, roleName: string){
		this.value = value;
		this.roleName = roleName;
	}
}

export class AccountModel {

	id: string;
	username: string;
	password: string;
	merchantId: string;
	firstname: string;
	lastname: string;
	email: string;
	enabled: boolean;
	hasToChangePassword: boolean;
	gender: string;
	roles: Role[];
	phones: string[];
	bookingOfficeUUID: string;
}



// WEBPACK FOOTER //
// ./src/app/models/account.model.ts